angular.module('impactx.user').directive('ixUserHeaderCard', function () {
    return {
        restrict: 'E',
        controller: function(){},
        controllerAs: 'userHeaderCardCtrl',
        scope: {
            image: "=?",
            imageReadonly: "=?",
            firstName: "=?",
            lastName: "=?",
            companyName: "=?",
            designator: "=?",
            userPhone: "=?",
            userMobile: "=?",
            userEmail: "=?",
            trns: "="
        },
        templateUrl: 'modules/userdialog/templates/userheadercard.tmpl.html'
    }
});